// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__2jntC","backButtonArrow":"BackButton_backButtonArrow__GMoJV","backButtonTitle":"BackButton_backButtonTitle__1qIgz"};